// extracted by mini-css-extract-plugin
export default {"main-container":"AccountingCallback_main-container__CPNAe"};